import {
  title_default
} from "../../chunk-L2AFJ2KW.js";
export {
  title_default as default
};
